import React, { useEffect, useState, Suspense, useCallback } from 'react';
import { Provider, useDispatch } from 'react-redux'; // Importiere den Redux-Provider
import ModulSidecart from './components/SideCart/ModulSidecart.tsx';
import { ReduxCheckoutProvider, useReduxStore } from './redux/checkoutredux/ReduxCheckoutContext.tsx';
import store from './redux/checkoutredux/store/checkoutStore.ts';

import { setSidecartSettings, setGeneralSettings } from './redux/checkoutredux/actions/settingsactions/settingsActions';
import { setAllCartData } from './redux/checkoutredux/actions/cartactions/fetchdirectActions';

import { RootState } from './redux/checkoutredux/store/checkoutStore';

const AppSideCart: React.FC = () => {
  return (
    <ReduxCheckoutProvider store={store}>
    <SideCartContent />
  </ReduxCheckoutProvider>
  );
};

// **SideCartContent** wird innerhalb des `Provider` verwendet
const SideCartContent: React.FC = () => {
  
  const store = useReduxStore();
  const currentState: RootState = store.getState(); 
  //const currentState = store.getState();

  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [isReady, setIsReady] = useState(false);

  //const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const toggleSidebar = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  useEffect(() => {
    //console.log("Dieser Code läuft nur einmal nach dem ersten Render!");
    const fetchData = async () => {
      const appSettings = window.appSettings || {}; // Globale Daten
      //console.log("AppSettings: ", appSettings);
      const generalData = window.ipsGeneralData || []; // Globale Daten

      if (Object.keys(appSettings).length > 0) {
        dispatch(setSidecartSettings(appSettings));
      }

      if (generalData.length > 0) {
        dispatch(setAllCartData(generalData[0]?.currentshoppingcart?.data || {}));
        dispatch(setGeneralSettings(generalData[0]?.generalData || {}));
      }

      setIsReady(true);
    };

    fetchData();
  }, [dispatch]);
//}, []); 

  return (
    <Suspense fallback={<p>Loading...</p>}>
     {isReady ? ( // Rendern, wenn der Zustand bereit ist
        <ModulSidecart sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      ) : (
        <p>Loading store data...</p>
      )}
    </Suspense>
  );
};

export default AppSideCart;